function getPageHeight() {
	var body = document.body,
		html = document.documentElement;

	return Math.max(body.scrollHeight, body.offsetHeight,
		html.clientHeight, html.scrollHeight, html.offsetHeight);
}

export default {
	watch: {
		'forms.active'(name) {
			// console.log('forms.active', name, 'Event( resize )', getPageHeight());

			// top.postMessage({
			// 	event_id: 'resize',
			// 	size: getPageHeight(),
			// }, '*');

			// top.postMessage(
            //     {
            //         event_id: 'scrollFrameTo',
            //         position: 'start',
            //     },
            //     '*'
            // );

			// this.$connector.step();
		}
	},
	data() {
		return {
			
			forms: {
				active: '',
				settings: {},
				open( name, settings ) {
					this.active = name;
					this.settings = settings;
				},
				close() {
					this.active = 'нет';
					this.settings = {};
				},
				// steps: {
				// 	Main : 1,
				// 	Rates : 2,
				// 	Questionnaire : 3,
				// 	AdditionalServices : 4,
				// 	StatusWaiting : 5,
				// 	// AccessApplication,
				// 	SelectedAccessApplication : 6,
				// 	Decline : 7,
				// 	Accept : 8,
				// 	Sms: 9,
				// },
				// getNameByStep(step) {
				// 	return Object.keys(this.steps).filter(key => this.steps[key] == step)[0];
				// },
				// getStepByName(name) {
				// 	return this.steps[name];

				// }
			},
		}
	}
}